const CER_INFO = 'CER_INFO';
import {
  getCertificate
} from '@/services/user'
const state = {
  info: {}
};
const mutations = {
  [CER_INFO](state, payload) {
    state.info = Object.assign({}, state.info, payload)
  }
}
const actions = {
  async certificateInit({
    commit
  }, payload) {
    let {
      data,
      status
    } = await getCertificate({
      competitionId: payload
    })
    if (status === 200) {
      let params = data;
      commit(CER_INFO, params)
    }
    
  }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
